const textsection_one = {
    heading: "We make global hiring easy for employers",
    subheading: "by offering services that handle the tricky aspects of employment, including compliance, payroll, and onboarding.",
    paragraph1: "Hiring employees worldwide involves navigating local labour laws, learning about tax implications, and trying to understand new engagement models.",
    paragraph2: "With Ampstekpay as your partner, we take the complexity out of international employment with services designed to ensure your business complies with each country’s unique requirements.",
    buttonText: "Find out more",
    className:"textsection_one",
    url:"/countries"
};
const textsection_two = {
    heading: "",
    subheading: "Hire Whoever, Wherever in the World. Manage Them in One Platform",
    paragraph1: "Manage your global workforce seamlessly – whether in the US, EU, or worldwide with our purpose-built workforce management technology. Whatever your business hiring needs are, our platform simplifies the process.",
    paragraph2: "",
    buttonText: "",
    className:"textsection_two"
};

const textsection_threecareer = {
    heading: "",
    subheading: "Open Positions at Ampstekpay.",
    paragraph1: "Be part of Ampstekpay mission to ‘Help companies hire talent; whoever and wherever in the world.’ Working for Ampstekpay provides you with a unique opportunity to be part of our clients’ journeys while they are going global.",
    paragraph2: "Be part of a growing global company with career progression opportunities. Check out our open positions below and explore the competitive benefits we can offer you. ",
    buttonText: "Current Vacancies",
    className:"textsection_threecareer",
    url:"/current-vacancies"
};

const textsection_threelistcareer = {
    heading: "",
    subheading: "Why Join Us?",
    paragraph1: "",
    paragraph2: " ",
    listItems: [
        "20 days holiday ",
        "Company pension",
        "Perks platform:Discounts on holidays, shopping, restaurants and more." ,
        "Employee value awards– Recognition and prizes"  ,
        "Training & career development"  ,
        "Opportunity for business travel"  ,
        "Progression opportunities– Grow as you help businesses grow globally",
        "Opportunities to be upskilled and gain industry-recognised qualifications",
        "Hybrid and remote working opportunities",
        "Competitive & transparent salaries",
        "Private medical healthcare"
      ],
    buttonText: "Current Vacancies",
    className:"textsection_threelistcareer"
};
const textsection_fourcontractor = {
    heading: "",
    subheading: "As a contractor of Ampstekpay, we’re committed to making sure you have all the information and support you need to work confidently no matter where you are in the world.",
    paragraph1: "Whether you have questions about payroll, onboarding, compliance, or general employment issues, our team is ready to assist you every step of the way. Our contractor care team is just a phonecall away, ready to address your questions or concerns quickly and efficiently.",
    paragraph2: "",
    buttonText: "",
    className:"textsection_fourcontractor"
};

const textsection_fiveexperts = {
    heading: "",
    subheading: "Leading your global expansion consultants & workforce management teams",
    paragraph1: "Meet the people leading Ampstekpay’s teams to provide global standard business expansion advice and workforce management solutions, no matter where you hire",
    paragraph2: "",
    buttonText: "",
    className:"textsection_fiveexperts"
};

const textsection_sixEor = {
    heading: "",
    subheading: "What is a Global Employer of Record?",
    paragraph1: "A Global Employer of Record (EOR) is a third-party company that facilitates the employment of workers in foreign countries, taking responsibility for compliance with local labour laws, payroll, taxes, and benefits.",
    paragraph2: "While you manage the day-to-day tasks of your employees, Ampstekpay takes care of payroll, tax compliance, benefits, and employment regulations; all tailored to the specific requirements of each region.In short, we are your go-to partner when you need to hire internationally but don’t want the hassle of setting up legal entities in each country",
    buttonText: "Download",
    className:"textsection_one"
};

export  { textsection_one , textsection_two ,textsection_threecareer,textsection_threelistcareer , textsection_fourcontractor, textsection_fiveexperts,textsection_sixEor};